import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LabelDialogComponent, LabelDialogData, LabelDialogResult } from './label-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class LabelDialogService {
  constructor(private dialog: MatDialog) {}

  /** A dialógus maga készíti el a címkét; sikerkor a szerver válaszával zárul. */
  open(data: LabelDialogData) {
    return this.dialog.open<LabelDialogComponent, LabelDialogData, LabelDialogResult>(
      LabelDialogComponent,
      {
        width: '46rem',
        maxWidth: 'calc(100vw - 1.5rem)',
        autoFocus: false,
        restoreFocus: false,
        disableClose: true,
        panelClass: 'bgf-label-dialog-panel',
        backdropClass: 'bgf-confirm-dialog-backdrop',
        data,
      },
    ).afterClosed();
  }
}
